/**
 * @generated SignedSource<<ef5e4f60a84d4fdda260ee52bb0fa0e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RealmOrder = "ALPHABETIC_ASC" | "ALPHABETIC_DESC" | "BY_INDEX" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NavigationData$data = {
  readonly id: string;
  readonly name: string | null | undefined;
  readonly nav: {
    readonly header: ReadonlyArray<{
      readonly name: string | null | undefined;
      readonly path: string;
    }>;
    readonly list: ReadonlyArray<{
      readonly hasChildren: boolean;
      readonly name: string | null | undefined;
      readonly path: string;
    }>;
    readonly listOrder: RealmOrder;
  };
  readonly path: string;
  readonly " $fragmentType": "NavigationData";
};
export type NavigationData$key = {
  readonly " $data"?: NavigationData$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavigationData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RealmNav",
      "kind": "LinkedField",
      "name": "nav",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RealmNavItem",
          "kind": "LinkedField",
          "name": "header",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RealmNavItem",
          "kind": "LinkedField",
          "name": "list",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasChildren",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "listOrder",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Realm",
  "abstractKey": null
};
})();

(node as any).hash = "88d76a4d6b5c3ad34db57214c3a86099";

export default node;
